import DashboardWidgetController from 'dashboard/components/dashboard-widget/dashboard-widget-controller';
import { checkAccess } from 'app/actions/app.actions';
import * as api from 'dashboard/resources/eft-amount.api';
import template from './eft-amount-widget.html';

const mapStateToThis = ({ config, dictionary, session }) => {
  const { locale, retailer } = session;
  const { usesMultipleSweepDates } = config;
  const terms = dictionary.terms[locale];

  return {
    retailer,
    usesMultipleSweepDates,
    terms,
  };
};

const mapDispatchToThis = {
  checkAccess,
};

// eslint-disable-next-line no-undef
@Inject('$scope', '$ngRedux', '$state', 'gettextCatalog')
class EftAmountWidgetController extends DashboardWidgetController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.isHistoryLinkVisible = this.checkAccess('eft.sales.history');
    const retailerId = this.$state.params.retailerNo || this.retailer.retailerId;
    this.loadDataAsync(() => api.fetchEftAmount(retailerId));
  }

  $onDestroy() {
    this.unsubscribe();
  }
}

export default class EftAmountWidgetComponent {
  constructor() {
    this.bindings = {
      isEditMode: '<',
      isRemovable: '<',
      removeWidget: '&?',
    };
    this.template = template;
    this.controller = EftAmountWidgetController;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/eft-amount/eft-amount-widget-component.js